<template>
    <div tabindex="-1">
        <!-- The Modal -->
        <div style="z-index: 9999999" v-bind:style="{ display: getOverlayDisplay }" v-bind:class="[getBackground ? 'modal-background' : '']" id="myModal" class="modal">

        <!-- Modal content -->
        <div class="modal-content" v-bind:class="[getSpecialClassNames]">
            <span v-if="getDisplayCloseIcon" class="close" @click="closeOverlay()">
                <svg class="close-overlay" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                </svg>
            </span>

            <p v-if="getTitle" class="title"><b>{{getTitle}}</b></p>
            <p v-bind:class="{ message: getTitle }" v-if="getMessage">{{getMessage}}</p>
            <div class="button-group" v-if="Object.keys(getButtons).length && getButtons.type === 'discard-challenge'">
                <button class="btn btn-light-arp" @click="closeOverlay()">KEEP EDITING</button>
                <button class="btn btn-warning-arp" @click="getButtons.successHandler()">DISCARD CHANGES</button>
            </div>
            <div class="button-group" v-if="Object.keys(getButtons).length && getButtons.type === 'clear-metrics-challenge'">
                <button class="btn btn-light-arp" @click="closeOverlay()">CANCEL</button>
                <button class="btn btn-warning-arp" @click="getButtons.successHandler()">CLEAR METRICS</button>
            </div>
            <div class="button-group" v-if="Object.keys(getButtons).length && getButtons.type === 'alert'">
                <button class="btn btn-warning-arp" @click="closeOverlay()">Okay</button>
            </div>
              <div class="button-group" v-if="Object.keys(getButtons).length && getButtons.type === 'challenge'">
                 <button class="btn btn-light-arp" @click="closeOverlay()">Cancel</button>
                 <button class="btn btn-warning-arp" @click="getButtons.successHandler()">Delete</button>
            </div>
        </div>

        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: "Overlay",
    computed: {
        ...mapGetters(['getOverlayDisplay', 'getTitle', 'getMessage', 'getSpecialClassNames', 'getButtons', 'getDuration', 'getIsNotification', 'getDisplayCloseIcon', 'getBackground']),
    },
        
    data(){
        return {
           buttonType : ''
            }
    },
    methods: {
        ...mapActions(['triggerOverlay']),
        closeOverlay: function () {
            this.triggerOverlay(false);
        },
        // When the user clicks anywhere outside of the modal, close it
        documentClick: function(event) {
            if (event.target == document.getElementById("myModal")) {
                this.closeOverlay();
            }
        },
    },
    created () {
      document.addEventListener('click', this.documentClick);
    },
    
    updated: function () {
        if (this.getDuration) {
            setTimeout(() => {
                this.closeOverlay();
            }, (this.getDuration * 1000));
        }
    },

    destroyed () {
        // important to clean up!!
        document.removeEventListener('click', this.documentClick);
    },
    watch: {
        //
    }
}
</script>

<style scoped>
.discard-sp-width {
    width: 670px;
}
/* The Modal (background) */
.modal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  /* z-index: 1; /* Sit on top */
  padding-top: 0; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  /* background-color: rgb(0,0,0); /* Fallback color */
  /* background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}
.modal-background {
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0,0.4);
}
/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.btn-light-arp {
    color: #000 !important;
    background-color: #fff !important;
    font-weight: bold !important;
}

.btn-warning-arp {
    color: #000 !important;
    background-color: #FBC743 !important;
    font-weight: bold !important;

}

.delete-comment {
    top: 35%;
    width: 38%;
}

.message {
    margin-top: 0px;
    margin-bottom: 30px;
}

.title {
    font-size: 20px;
}

.button-group {
    margin-left: auto;
    margin-right: 0px;
}

.button {
    margin-left: 12px;
    margin-right: 12px;
    background-color: white; 
    color: #008CBA;; 
    border: 2px solid #008CBA;
    padding: 8px 32px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 4px 2px;
    cursor: pointer;
}

#buttonDelete {
    color: #A4ADB3;
    background-color: #008CBA;
}

.download-in-progress {
    background-color: #fff5cc;
    margin-right: 16px;
    width: 220px;
    height: 60px;
    color: #000000;
    margin-top: 2px;
}

.download-success {
    background-color: #99e699;
    margin-right: 16px;
    width: 220px;
    height: 60px;
    color: 000000;
    margin-top: 2px;
}

.download-failure {
    background-color: #ff9980;
    margin-right: 16px;
    width: 220px;
    height: 60px;
    color: 000000;
    margin-top: 2px;
}

.download-no-records {
    background-color: #ff9980;
    margin-right: 16px;
    width: 380px;
    height: 60px;
    color: 000000;
    margin-top: 2px;
}

/* The Close Button */
.close {
  color: #C12F24;
  position: absolute;
  right: 8px;
  top: 4px;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: rgb(104, 10, 3);
  text-decoration: none;
  cursor: pointer;
}

.close-overlay {
    width: 26px;
    height: 26px;
}

.delete-comment.delete-modal .close-overlay{
    fill: #000;
    color: #000;
}
</style>

